import { Component, OnInit } from '@angular/core';
import { ProdEntityWithProjects } from '@data/productionEntity/prod-entity';
import { ProdEntityService } from '@data/productionEntity/prod-entity.service';
import { CommonConstants } from '@mpg-core/constants/common-constants';
import { ConfirmationPopupOption, ConfirmationResponse } from '@shared/common-components/confirmation-popup/confirmation-popup.component';
import { LoadPanelOption } from '@shared/common-components/load-panel/load-panel.component';
import { CommonDataService } from '@shared/services/common-data.service';

@Component({
    selector: 'app-manage-production-entity',
    templateUrl: './manage-production-entity.component.html',
    styleUrls: ['./manage-production-entity.component.less'],
    standalone: false
})
export class ManageProductionEntityComponent implements OnInit {

  prodEntityList: ProdEntityWithProjects[] = [];
  prodEntityId: number;
  prodEntityDescription: any;
  openConfirmationPopup: boolean = false;
  confirmationPopupOption: ConfirmationPopupOption;
  isAdminOrFinExec: boolean = false;
  showLoadPanel: boolean = false;
  loadPanelOption:LoadPanelOption={
    closeOnOutsideClick:false,
    message:"loading...",
    visible:true,
    showPane:true,
    ofPosition:'#publishHistoryGrid',
    shadingColor:'rgba(0,0,0,0.05)'
  };
  deleteStatusOptions:any[];

  constructor(private _manageProdEntity: ProdEntityService, private commonDataService: CommonDataService) {
    this.fetchProdEntity();
    if (this.commonDataService.userInfo.value.userRole.roleId === CommonConstants.SUPER_ADMIN_ROLE_ID
      || this.commonDataService.userInfo.value.userRole.roleId === CommonConstants.FINANCE_EXEC_ROLE_ID){
        this.isAdminOrFinExec = true;
      };
      this.allowProdEntityDelete = this.allowProdEntityDelete.bind(this);
      this.allowProdEntityUpdate = this.allowProdEntityUpdate.bind(this);
      this.deleteStatusOptions = this._manageProdEntity.getDeleteStatusOptions();
   }

  ngOnInit(): void {
    
  }

  fetchProdEntity(){
    this.showLoadPanel=true;
    this._manageProdEntity.getProdEntityList().subscribe(
      r=>{
        if(r.status=="SUCCESS"){
          this.prodEntityList = r.serviceResult??[];
          this.showLoadPanel=false;
        }
      });
  }

  allowProdEntityDelete(e:any) {
    return (this.isAdminOrFinExec && !e.row.data.isDelete) as boolean;
  }

  allowProdEntityUpdate(e:any) {
    return (this.isAdminOrFinExec) as boolean;
  }

  deleteStatus(data:any) {
    if (data.value && data.value == true)
      return "INACTIVE";
    else return "ACTIVE";
  }

  onProdEntityRowRemoving(e:any){
    e.cancel=true;
    this.prodEntityId = e.data.productionEntityId;
    this.prodEntityDescription = e.data.entityDescription;
    this._manageProdEntity.doesEntityHaveProject(this.prodEntityId).subscribe(
      r=>{
        if(r.serviceResult){
          this.confirmProdEntityDeletion();
        }else {
          this.softDeleteProdEntity();
        }
      }
    );
  }

  confirmProdEntityDeletion() {
    this.confirmationPopupOption = {
      message: 'The selected entity is associated with one or more Projects.Do you want to proceed ?',
      rejectButtonText: 'NO',
      normalButtonText: '',
      confirmButtonText: 'YES',
      showCloseButtn: false,
      visible: true,
      option: 'confirmDelete',
    };
    this.openConfirmationPopup = true;
  }

  confirmationChanges(res: ConfirmationResponse) {
    this.openConfirmationPopup = false;
    if (res.option == 'confirmDelete' && res.confirmation) {
      this.softDeleteProdEntity();
    } 
  }

  softDeleteProdEntity(){
    this.showLoadPanel=true;
    this._manageProdEntity.updateProdEntity(
      {
        "productionEntityId":this.prodEntityId,
        "entityDescription":this.prodEntityDescription,
        "isDelete": true
      }
    ).subscribe(
      r=>{
        if(r.status=="SUCCESS"){
          if(r.serviceResult){
            this.fetchProdEntity();
            this.commonDataService.fetchAllCommonData();
          }
        }
      }
            
    );
  }

  updateProdEntity(e:any){
    this.showLoadPanel=true;
    this._manageProdEntity.updateProdEntity(
      {
        "productionEntityId":e.key.productionEntityId,
        "entityDescription":e.key.entityDescription,
        "isDelete": e.key.isDelete
      }
    ).subscribe(
      r=>{
        if(r.status=="SUCCESS"){
          if(r.serviceResult){
            this.fetchProdEntity();
            this.commonDataService.fetchAllCommonData();
          }
        }
      }
            
    );
  }

}
